import React from "react";
import SubscriptionList from "./SubscriptionList";

/**
 * Support only. The reporting that used to sit behind a tab here now lives in the Reports
 * section under its own permission - reading how the plans are selling is a finance
 * question, while this screen carries the power to cancel a plan and refund it.
 */
const CustomerSubscriptions = () => {
  return (
    <div className={`pro-w-100`}>
      <SubscriptionList />
    </div>
  );
};

export default CustomerSubscriptions;
